<template>
  <div>
    <!-- Trackable Ad 4 Image -->
    <v-img
      src="../assets/4.png"
      @click="handleClick"
      style="cursor: pointer"
    ></v-img>


  </div>
</template>

<script>
import { onMounted } from 'vue';
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  increment
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: 'TrackableImageAd4',
  data() {
    return {
      ad4Views: 0,
      ad4Clicks: 0
    };
  },
  async mounted() {
    // Increment view count on mount, then fetch latest stats
    await this.incrementAd4View();
    await this.fetchAd4Stats();
  },
  methods: {
    // Fetch the current ad4Views and ad4Clicks from Firestore
    async fetchAd4Stats() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        const data = statsSnap.data();
        this.ad4Views = data.ad4Views || 0;
        this.ad4Clicks = data.ad4Clicks || 0;
      } else {
        // If doc doesn't exist yet, initialize local state
        this.ad4Views = 0;
        this.ad4Clicks = 0;
      }
    },

    // Increment the Ad 4 view count
    async incrementAd4View() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad4Views: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad4Views: 1,
          ad4Clicks: 0
        });
      }
    },

    // Increment the Ad 4 click count
    async incrementAd4Click() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad4Clicks: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad4Views: 0,
          ad4Clicks: 1
        });
      }
    },

    // Handle click: update Firestore, refresh stats, then open landing page in new tab
    async handleClick() {
      await this.incrementAd4Click();
      await this.fetchAd4Stats();
      window.open(
        'http://static.clvads.com/durbanjuly_farpost/index.html',
        '_blank',
        'noopener,noreferrer'
      );
    }
  }
};
</script>

<style scoped>
.v-image--image {
  transition: opacity 0.3s ease;
}
.v-image--image:hover {
  opacity: 0.8;
}
.ad-stats p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
}
</style>
